/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Coral_Toad_PokeInputs */

const en_keen_coral_toad_poke = /** @type {(inputs: Keen_Coral_Toad_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const de_keen_coral_toad_poke = /** @type {(inputs: Keen_Coral_Toad_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviert`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Keen_Coral_Toad_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_coral_toad_poke = /** @type {((inputs?: Keen_Coral_Toad_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Coral_Toad_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_coral_toad_poke(inputs)
	return de_keen_coral_toad_poke(inputs)
});